import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/aviso-legal")({
  head: () => ({
    meta: [
      { title: "Aviso Legal — Bizaclia.com" },
      {
        name: "description",
        content:
          "Información legal sobre Bizaclia.com: datos del titular, condiciones de uso y responsabilidad.",
      },
    ],
  }),
  component: AvisoLegalPage,
});

function AvisoLegalPage() {
  return (
    <main className="container mx-auto max-w-3xl px-4 sm:px-6 py-16 sm:py-24">
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition mb-8"
      >
        <ArrowLeft className="h-4 w-4" />
        Volver al inicio
      </Link>

      <h1 className="font-display font-bold text-3xl sm:text-4xl tracking-tight">
        Aviso Legal
      </h1>
      <p className="mt-2 text-muted-foreground text-sm">
        Última actualización: junio de 2026
      </p>

      <div className="mt-10 space-y-10 text-foreground/90 leading-relaxed">
        <section>
          <h2 className="font-semibold text-lg mb-3">1. Datos identificativos</h2>
          <p>
            En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de
            la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa que el
            titular de este sitio web es:
          </p>
          <ul className="mt-3 space-y-1 list-disc pl-5">
            <li><strong>Razón social:</strong> BIZACLIA SL</li>
            <li><strong>NIF:</strong> B88822986</li>
            <li><strong>Domicilio social:</strong> Avenida Más Fuster 27, 08197 Sant Cugat del Vallès, Barcelona, España</li>
            <li><strong>Email:</strong> info@bizaclia.com</li>
            <li><strong>Teléfono:</strong> 900 433 065</li>
            <li><strong>Inscripción:</strong> Registro Mercantil de Barcelona</li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-lg mb-3">2. Objeto y ámbito de aplicación</h2>
          <p>
            El presente aviso legal regula el acceso y uso del sitio web{" "}
            <strong>bizaclia.com</strong> (en adelante, "el Portal"), propiedad de BIZACLIA SL
            (en adelante, "Bizaclia").
          </p>
          <p className="mt-2">
            El Portal tiene como finalidad poner en contacto a personas interesadas en el
            alquiler, venta o traspaso de locales comerciales, oficinas y naves industriales
            (en adelante, "inmuebles comerciales"), facilitando la publicación de anuncios y la
            gestión de solicitudes de contacto entre usuarios.
          </p>
          <p className="mt-2">
            La navegación, acceso y uso del Portal implica la aceptación expresa de las
            condiciones recogidas en este aviso legal, en la política de privacidad y en los
            términos y condiciones de uso, sin perjuicio de la aplicación de la normativa
            vigente en materia de consumo, comercio electrónico y protección de datos.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg mb-3">3. Condiciones de acceso y uso</h2>
          <p>
            El acceso al Portal es gratuito para los usuarios que lo consulten. No obstante,
            ciertos servicios (como la publicación de anuncios o la gestión de solicitudes a
            través de MyBizaclia) requieren el registro previo como usuario y la aceptación de
            las correspondientes condiciones específicas.
          </p>
          <p className="mt-2">
            El usuario se compromete a utilizar el Portal, sus servicios y contenidos de
            conformidad con la legislación vigente, la buena fe, el orden público y los usos
            generalmente aceptados. Queda expresamente prohibido:
          </p>
          <ul className="mt-3 space-y-1 list-disc pl-5">
            <li>
              Publicar anuncios que contengan información falsa, engañosa o que infrinja
              derechos de terceros.
            </li>
            <li>
              Utilizar el Portal para transmitir, almacenar o difundir virus, malware o
              cualquier código destinado a interrumpir, destruir o limitar la funcionalidad de
              los equipos o sistemas informáticos.
            </li>
            <li>
              Reproducir, distribuir o comunicar públicamente los contenidos del Portal sin
              autorización expresa de Bizaclia.
            </li>
            <li>
              Realizar actividades que supongan una explotación comercial no autorizada del
              Portal o de sus bases de datos.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="font-semibold text-lg mb-3">4. Propiedad intelectual e industrial</h2>
          <p>
            Todos los contenidos del Portal (textos, fotografías, gráficos, imágenes, iconos,
            software, bases de datos, diseño, estructura de navegación, código fuente, marcas,
            logotipos y demás elementos susceptibles de protección) son propiedad de Bizaclia
            o de terceros que han autorizado su inclusión en el Portal, y están protegidos por
            la normativa española e internacional de propiedad intelectual e industrial.
          </p>
          <p className="mt-2">
            Queda prohibida la reproducción, transformación, distribución, comunicación
            pública, puesta a disposición, extracción, reutilización, reenvío o utilización de
            cualquier naturaleza, por cualquier medio o procedimiento, de cualquiera de los
            contenidos del Portal, salvo en los casos expresamente autorizados por ley o
            consentidos expresamente por escrito por Bizaclia.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg mb-3">5. Responsabilidad</h2>
          <p>
            <strong>Responsabilidad de Bizaclia:</strong> Bizaclia no garantiza la
            disponibilidad y continuidad del funcionamiento del Portal y de los servicios,
            ni la utilidad, exactitud o fiabilidad de los contenidos, aunque actuará con la
            diligencia necesaria para restablecer el servicio en caso de incidencia. Bizaclia
            no se responsabiliza de los daños y perjuicios que pudieran derivarse de la
            presencia de virus u otros elementos lesivos en los contenidos que puedan
            producir alteraciones en los sistemas informáticos de los usuarios.
          </p>
          <p className="mt-2">
            <strong>Responsabilidad del usuario:</strong> El usuario es el único responsable
            de la veracidad y licitud de los datos e informaciones que facilite a través del
            Portal, así como de los anuncios que publique. Bizaclia se reserva el derecho a
            suspender o cancelar la cuenta de cualquier usuario que incumpla las presentes
            condiciones.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg mb-3">6. Enlaces</h2>
          <p>
            El Portal puede contener enlaces a sitios web de terceros. Bizaclia no ejerce
            control sobre dichos sitios ni asume responsabilidad alguna sobre sus contenidos,
            servicios o políticas de privacidad. La inclusión de un enlace no implica
            necesariamente la existencia de relaciones entre Bizaclia y el propietario del
            sitio enlazado, ni la aceptación y aprobación de sus contenidos o servicios.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg mb-3">7. Modificaciones</h2>
          <p>
            Bizaclia se reserva el derecho a modificar, en cualquier momento y sin previo
            aviso, la presentación, configuración y contenidos del Portal, así como las
            condiciones de uso recogidas en este aviso legal. El usuario será responsable de
            consultar periódicamente el presente aviso legal para conocer las posibles
            modificaciones que se introduzcan.
          </p>
        </section>

        <section>
          <h2 className="font-semibold text-lg mb-3">8. Legislación aplicable y jurisdicción</h2>
          <p>
            El presente aviso legal se rige por la legislación española. Para la resolución de
            cualquier controversia que pudiera derivarse del acceso o uso del Portal, las
            partes se someten a los juzgados y tribunales de la ciudad de Barcelona, con
            renuncia expresa a cualquier otro fuero que pudiera corresponderles.
          </p>
        </section>
      </div>
    </main>
  );
}
